import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateLessonContentById: build.mutation<
      UpdateLessonContentByIdApiResponse,
      UpdateLessonContentByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/lesson-contents/${queryArg.id}`,
        method: "PUT",
        body: queryArg.lessonContentUpdateRequest,
      }),
    }),
    deleteLessonContentById: build.mutation<
      DeleteLessonContentByIdApiResponse,
      DeleteLessonContentByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/lesson-contents/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type UpdateLessonContentByIdApiResponse =
  /** status 200 OK */ SuccessResponse200;
export type UpdateLessonContentByIdApiArg = {
  /** uuid */
  id: string;
  /** Lesson content update */
  lessonContentUpdateRequest: LessonContentUpdateRequest;
};
export type DeleteLessonContentByIdApiResponse =
  /** status 200 OK */ SuccessResponse200;
export type DeleteLessonContentByIdApiArg = {
  /** uuid */
  id: string;
};
export type SuccessResponse200 = {
  status?: string;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export type EntityLessonContentType =
  | "lct-theory"
  | "lct-experiment"
  | "lct-reminder"
  | "lct-scale";
export type EntityLessonContentStatus =
  | "lcs-active"
  | "lcs-preview"
  | "lcs-draft";
export type EntityLanguage = "en" | "de" | "de";
export type RequestNoteMetaDataUpdateRequest = {
  placeholder: string;
};
export type RequestScaleMetaDataUpdateRequest = {
  /** Markdown supported */
  content: string;
  /** Markdown supported */
  maxLabel: string;
  maxValue: number;
  /** Markdown supported */
  minLabel: string;
  minValue: number;
};
export type LessonContentUpdateRequestTranslation = {
  language: EntityLanguage;
  name: string;
  noteMetaData?: RequestNoteMetaDataUpdateRequest;
  scaleMetaData?: RequestScaleMetaDataUpdateRequest;
  /** Markdown supported */
  text: string;
};
export type LessonContentUpdateRequest = {
  lessonContentType: EntityLessonContentType;
  mediaId?: string;
  order: number;
  status: EntityLessonContentStatus;
  translations: LessonContentUpdateRequestTranslation[];
};
export const {
  useUpdateLessonContentByIdMutation,
  useDeleteLessonContentByIdMutation,
} = injectedRtkApi;
